import React, { useState } from "react";
import rocketIcon from "../../../../assets/images/rocketIcon.svg";
import wordpress from "../../../../assets/images/wordpress.svg";
import geocoder from "../../../../assets/images/geocoderIcon.svg";
import hubSpot from "../../../../assets/images/hubSpotIcon.svg";
import drupal from "../../../../assets/images/drupalIcon.svg";
import wix from "../../../../assets/images/wixcom-logo.png";
import { useNavigate } from "react-router-dom";

const ProjectTypeForm = () => {
  const [selectedProjectType, setSelectedProjectType] = useState(null);

  const navigate = useNavigate();

  const projectTypes = [
    { id: 1, name: "Geocoder", logo: geocoder },
    { id: 2, name: "WordPress", logo: wordpress },
    { id: 3, name: "HubSpot", logo: hubSpot },
    { id: 4, name: "Drupal", logo: drupal },
    { id: 5, name: "Wix", logo: wix },
  ];

  const handleSelect = (type) => {
    setSelectedProjectType(type);
    localStorage.setItem("selectedProjectType", JSON.stringify(type));
    navigate("/projects/create-project");
  };

  return (
    <div className="px-[35px] project-type-form">
      <div className="max-w-[757px] w-full bg-white p-[27px] rounded-[10px] border-[1px] border-[#E0E0E0]">
        <div className="flex items-center mb-[19px]">
          <img src={rocketIcon} alt="Rocket Icon" />
          <div className="ml-[16px]">
            <h3 className="text-[17px] font-semibold mb-0 flex items-center">
              What Platform is Your Website Built on?
            </h3>
            <p className="text-[12px] text-[#8C8C8C]">
              Select the corresponding project type
            </p>
          </div>
        </div>

        <div className="flex wrapper-buttons flex-wrap gap-[14px] md:gap-0">
          {projectTypes.map((type, i) => (
            <button
              key={type.id ?? i}
              onClick={() => handleSelect(type)}
              className={`w-full sm:w-[48%] md:w-[23%] py-2 px-4 my-2 border rounded-lg text-center ${
                selectedProjectType?.id === type.id
                  ? "border-orange-500"
                  : "border-gray-300 bg-white"
              }`}
            >
              <img
                src={type.logo}
                alt={type.name}
                className="mx-auto h-[96px] p-[15px]"
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectTypeForm;
